import { VerifiedByVisa, MasterCard, PciDss, PaypalVerified, SecureEncryption } from "@/utils/miscIcons";
import s from "@/components/Misc/LogoContainer.module.scss";

const getLogoRepeater = () => {
  let logoRepeater = window?.post_template?.payment_logo_repeater;
  if (typeof logoRepeater === "string") {
    try {
      logoRepeater = JSON.parse(logoRepeater);
    } catch (e) {
      logoRepeater = [];
    }
  }
  return Array.isArray(logoRepeater) ? logoRepeater : [];
};

const fallbackIcons = [
  { Component: VerifiedByVisa, alt: "Verified By Visa" },
  { Component: MasterCard, alt: "MasterCard" },
  { Component: PciDss, alt: "PCI DSS" },
  { Component: PaypalVerified, alt: "Verified By Paypal" },
  { Component: SecureEncryption, alt: "Secure Encryption" },
];

const LogoContainer = () => {
  const logoRepeater = getLogoRepeater();

  return (
    <div className={s.logoContainer}>
      {logoRepeater.length > 0
        ? logoRepeater.map((item, idx) => <img src={item.image} key={idx} alt={`Payment logo ${idx + 1}`} />)
        : fallbackIcons.map(({ Component, alt }, idx) => <Component key={alt} alt={alt} />)}
    </div>
  );
};

export default LogoContainer;
